<script>
    import { convert, getActionLog } from './ui.js';
    import { state as _state, res, ui, prefs } from './stores.js';
    import { allActions, inPlay } from './card_actions.js';
    import LogCard from './LogCard.svelte';
    import { isMe } from './net.js';
    import { cardByID } from './game.js';


    export let log = '';
    export let p;
    export let showCaptain = false;
    export let params = null;
    export let state = $_state;
    export let type = '';
    export let filter = '';
    export let grey = false;

    function getLogCard(s){
        let hidden = false;
        let seen = false;
        if(s.startsWith('|h')){
            s = s.replaceAll('h', '');
            hidden = true;
        }
        if(s.startsWith('|v')){
            s = s.replaceAll('v', '');
            seen = true;
        }
        let id = s.slice(1, s.length - 1);
        let p;
        //console.log(id);
        if(id.includes(',')){
            let [newP, newID] = id.split(',');
            id = newID;
            p = newP;
        }
        let c = cardByID(id);
        return {p, c, hidden, seen};
    }

    let hiddenMarketDecks = ['encounters', 'locations', 'missions', 'incidents'];

    function visible(c, p, _state, _prefs, lc){
        if(!c) return true;
        if($ui.tab != 'game') return true; // Outside of game context, show all cards
        if($prefs.showAllCards) return true;
        let info = _state.cardLog[c.uniqueID];
        
        if(p == undefined || _state.players[p].username == $prefs.username && !_state.players[p].bot) return true; // Don't see bot cards
        if(lc.hidden) return false;
        if(lc.seen) return true;
        if(params && params.hasOwnProperty('hidden')){
            if(typeof params.hidden == 'boolean'){
                return !params.hidden;
            }else if(params.hidden.hasOwnProperty(c.uniqueID)){
                return !params.hidden[c.uniqueID];
            }
        }

        let visibleTypes = ['played', 'activated', 'refreshed', 'dismissed', 'discarded', 'returned', 'took control of'];
        
        if(visibleTypes.some(v => log.includes(` ${v} `))) return true; // 

        if(type == 'play' || type == 'freeplay' || type == 'activate' || type == 'play_activate' || type == 'refresh' || type == 'dismiss' || type == 'discard' || type == 'return') return true;

       /* let alwaysVisibleVerbs = ['played', 'discarded', 'dismissed', 'junked', 'activated']

        if(log && log.event == 'action' && getActionLog(log) && (alwaysVisibleVerbs.some(v => getActionLog(log).toLowerCase().includes(' '+v)))){
            return true;
        }*/
        //console.log(info, p, inPlay(c))
        if(info.area == 'commons'){
            if(hiddenMarketDecks.includes(info.deck)) return false;
        }else if(info.area == 'players'){
            if(inPlay(c)) return true;
            if(info.deck == 'play') return true;
            if(info.deck == 'discard') return true;
            return false;
        }
        return true;
    }

</script>
{#if log}
    {#if log.hasOwnProperty('event')}
        {#if log.event == 'action'}
            <svelte:self p={log.p} type={log.type} log={getActionLog(log, showCaptain)} params={log.params} {filter} />
        {:else if log.event == 'text'}
            <svelte:self p={log.p} log={log.text} {filter} grey={log.g} />
        {:else if log.event == 'playerTurn'}
            <div class="turn">Turn {log.turn}, {state.players[log.player].captain}'s go</div>
        {:else if log.event == 'phase'}
            <div class="phase">{log.phase[0].toUpperCase()}{log.phase.slice(1)} phase</div>
        {/if}
    {:else}
        <!-- filter.length == 0 ||  --> <!--  && getLogCard(s).name.toLowerCase().includes(filter.toLowerCase())) -->
        <!--{#if log.split('$').some(s => s.startsWith('|'))}-->
            {#each log.split('$') as s}
                    {#if s.startsWith('|')}
                        <LogCard textSize={2} c={getLogCard(s).c} visible={visible(getLogCard(s).c, getLogCard(s).p, state, $prefs, getLogCard(s))}/>
                    {:else if s.startsWith('!')}
                        <span class="grey">{@html convert(s.slice(1), true)}</span>
                    {:else}
                        {#if grey}
                            <span class="grey">{@html convert(s, true)}</span>
                        {:else}
                            {@html convert(s, true)}
                        {/if}
                    {/if}
            {/each}
        <!--{/if}-->
    {/if}
{/if}
<style>
    .grey {
        font-style: italic;
        color: goldenrod;
    }
    .turn {
        font-weight: bold;
        text-decoration: underline;
        font-size: 1.2em;
        margin-bottom: 0.2em;
    }

    .phase {
        font-style: italic;
        font-weight: bold;
        font-size: 1em;
        margin-bottom: 0.1em;
    }
</style>